import type { ModalComponentProps, ModelControlProps } from '@qse/constants'
import { ModelControlEnum } from '@qse/constants'
import type { ComponentType, FC } from 'react'

import AccessDeniedModal from './_components/access-denied-modal'
import AddReseller from './_components/add-reseller'
import AddTenant from './_components/add-tenant'
import AddUser from './_components/add-user'
import ApiKeyDetiles from './_components/api-key-details'
import BillingModal from './_components/billing-modal'
import BulkInvite from './_components/bulk-invite'
import ConfirmationModal from './_components/confirmation'
import CreateFolder from './_components/create-folder'
import CreatePlanModal from './_components/create-plan-modal'
import DeleteTenantConfirmationModal from './_components/delete-tenant-confirmation-modal'
import DeleteUserConfirmationModal from './_components/delete-user-confirmation-modal'
import DriveSetupModal from './_components/drive-setup-modal'
import FilePreviewModal from './_components/file-preview-modal'
import FolderFailuresModal from './_components/folder-failures-modal'
import MoveConflictModal from './_components/move-conflict-modal'
import MoveItemsModal from './_components/move-items-modal'
import NavigationWarningModal from './_components/navigation-warning-modal'
import QuotaExceededModal from './_components/quota-exceeded-modal'
import RenameFile from './_components/rename-file'
import TransferAdminModal from './_components/transfer-admin-modal'
import TwoFADisable from './_components/two-fa-disable'
import TwoFASetup from './_components/two-fa-setup'
import TwoFAVerify from './_components/two-fa-verify'
import UpdatePassword from './_components/update-password'
import ViewTenant from './_components/view-tenant'
export * from './_components'

const MODELS_MAP = new Map<ModelControlEnum, ComponentType<ModalComponentProps>>([
  [ModelControlEnum.CONFIRMATION, ConfirmationModal],
  [ModelControlEnum.ADD_USER, AddUser],
  [ModelControlEnum.BULK_INVITE, BulkInvite],
  [ModelControlEnum.ADD_TENANT, AddTenant],
  [ModelControlEnum.VIEW_TENANT, ViewTenant],
  [ModelControlEnum.API_KEY_DETAILS, ApiKeyDetiles],
  [ModelControlEnum.BILLING, BillingModal],
  [ModelControlEnum.CREATE_FOLDER, CreateFolder],
  [ModelControlEnum.CREATE_PLAN, CreatePlanModal],
  [ModelControlEnum.DRIVE_SETUP, DriveSetupModal],
  [ModelControlEnum.FILE_PREVIEW, FilePreviewModal],
  [ModelControlEnum.FOLDER_FAILURES, FolderFailuresModal],
  [ModelControlEnum.MOVE_ITEMS, MoveItemsModal],
  [ModelControlEnum.MOVE_CONFLICT, MoveConflictModal],
  [ModelControlEnum.RENAME_FILE, RenameFile],
  [ModelControlEnum.TRANSFER_ADMIN, TransferAdminModal],
  [ModelControlEnum.UPDATE_PASSWORD, UpdatePassword],
  [ModelControlEnum.ADD_RESELLER, AddReseller],
  [ModelControlEnum.TWO_FA_SETUP, TwoFASetup],
  [ModelControlEnum.TWO_FA_VERIFY, TwoFAVerify],
  [ModelControlEnum.TWO_FA_DISABLE, TwoFADisable],
  [ModelControlEnum.ACCESS_DENIED, AccessDeniedModal],
  [ModelControlEnum.NAVIGATION_WARNING, NavigationWarningModal],
  [ModelControlEnum.QUOTA_EXCEEDED, QuotaExceededModal],
  [ModelControlEnum.DELETE_USER_CONFIRMATION, DeleteUserConfirmationModal],
  [ModelControlEnum.DELETE_TENANT_CONFIRMATION, DeleteTenantConfirmationModal],
])

/**
 * Render a specific modal implementation based on the provided control enum.
 */
const ModelControl: FC<ModelControlProps> = props => {
  const {
    control = ModelControlEnum.CONFIRMATION,
    setModelActive,
    setToggleModel,
    toggleModel,
    onClose,
    reset,
    data,
  } = props
  const Component = MODELS_MAP.get(control)

  // Convert ModelControlProps to ModalComponentProps
  const modalProps: ModalComponentProps = {
    data,
    reset,
    setModelActive: (model: ModelControlEnum | undefined, additionalData?: any) => {
      setModelActive(model || ModelControlEnum.CONFIRMATION, additionalData)
    },
    setToggleModel,
    toggleModel,
    onClose,
  }

  return Component ? <Component {...modalProps} /> : null
}

export default ModelControl
